import type { CSSProperties } from 'react';

import classes from './ErrorMessage.module.scss';

type Props = {
	error?: string;
	visible: boolean;
	style?: CSSProperties;
};

const ErrorMessage: React.FC<Props> = ({ error, visible, style }: React.PropsWithChildren<Props>) => {
	if (!visible || !error) {
		return <div className={classes['placeholder']} />;
	}

	return (
		<div className={classes['errorContainer']}>
			<span className={classes['error']} style={style}>
				{error}
			</span>
		</div>
	);
};

export default ErrorMessage;
